import {TalentPoolFilterData, TalentPoolListItem, TalentPoolPagination} from '../types/TalentPoolTypes';

import {ApiSerializer} from '../../../../../serializers/ApiSerializer';

const emptyPagination: TalentPoolPagination = {
  page: 1,
  perPage: 25,
  totalPages: 0,
  totalCount: 0,
  nextPage: null,
  previousPage: null,
};

/**
 * Maps raw JSON `{ talent_pool: { data, pagination, filter_data } }` into the shape
 * expected by `useQueryPagination`.
 */
export function mapTalentPoolApiToPaginationResponse(raw: unknown): {
  data: TalentPoolListItem[];
  pagination: TalentPoolPagination;
  filterData?: TalentPoolFilterData;
} {
  const body = ApiSerializer.toCamelCase(raw) as {
    talentPool?: {
      data?: TalentPoolListItem[];
      pagination?: TalentPoolPagination;
      filterData?: TalentPoolFilterData;
    };
  };

  const tp = body.talentPool;
  if (!tp) {
    return {data: [], pagination: emptyPagination};
  }

  let filterData: TalentPoolFilterData | undefined;
  if (tp.filterData && typeof tp.filterData === 'object') {
    filterData = {
      campaigns: Array.isArray(tp.filterData.campaigns) ? tp.filterData.campaigns : [],
      statuses: Array.isArray(tp.filterData.statuses) ? tp.filterData.statuses : [],
    };
  }

  return {
    data: Array.isArray(tp.data) ? tp.data : [],
    pagination: tp.pagination ? {...emptyPagination, ...tp.pagination} : emptyPagination,
    ...(filterData && (filterData.campaigns.length || filterData.statuses.length) ? {filterData} : {}),
  };
}
